import { getSlidesPerView } from './getSlidesPerView';
export const shouldShowNavigationArrows = ({
  navigation,
  slider,
  slidesCount
}) => navigation?.showArrows === true && slidesCount > getSlidesPerView(slider);
//# sourceMappingURL=shouldShowNavigationArrows.js.map